import React from 'react';

import slide_1 from '../../../assets/img/about-slider/about-slide-1.png';
import slide_2 from '../../../assets/img/about-slider/about-slide-2.png';
import slide_3 from '../../../assets/img/about-slider/about-slide-3.png';
import slide_4 from '../../../assets/img/about-slider/about-slide-4.png';
// import slide_5 from '../../../assets/img/about-slider/about-slide-5.png';
import slide_6 from '../../../assets/img/about-slider/about-slide-6.png';
import slide_7 from '../../../assets/img/about-slider/about-slide-7.png';
import slide_8 from '../../../assets/img/about-slider/about-slide-8.png';
import slide_9 from '../../../assets/img/about-slider/about-slide-9.png';

import 'swiper/css';
import './Carousel.scss';

export const carouselData = [
  {
    title: 'AI расчёт воды',
    description:
      'Определяйте объем жидкости по фото и следите за нормой потребления воды',
    img: slide_1,
  },
  {
    title: 'AI расчёт КБЖУ',
    description: 'Легкий подсчет калорий и точные результаты по фото',
    img: slide_2,
  },
  {
    title: 'AI расчет параметров тела',
    description: 'Легко отслеживайте изменения тела по фото',
    img: slide_3,
  },
  {
    title: 'Прогресс за день',
    description:
      'Нутриентный состав продуктов на диаграмме: следите за результатом каждый день',
    img: slide_4,
  },
  // {
  //   title: 'AI расчёт воды',
  //   description: 'Определите объем жидкости с помощью камеры телефона.',
  //   img: slide_5,
  // },
  {
    title: 'AI тренер',
    description: 'Индивидуальный фитнес-план и контроль выполнения упражнений',
    img: slide_6,
  },
  {
    title: 'Планируйте ЗОЖ',
    description:
      'Формируйте шаги по достижению цели вместе с персональным AI ассистентом',
    img: slide_8,
  },
  {
    title: 'Анализ и контроль прогресса',
    description:
      'Оптимизируйте время, следите за результатами и улучшайте качество жизни',
    img: slide_7,
  },
  {
    title: 'Поддержка и мотивация',
    description:
      'Ваша дорога к успеху: поддержка, мотивация и советы на каждом этапе',
    img: slide_9,
  },
];

const Carousel = ({ activeSlide }) => {
  const adjustedActiveSlide = Math.min(
    Math.max(activeSlide, 1),
    carouselData.length
  );

  return (
    <div className="image-carousel container">
      <div className="carousel-wrapper">
        <div className="carousel" style={{ '--activeSlide': `${activeSlide}` }}>
          {carouselData.map((item, i) => (
            <div
              className="carousel-slide"
              data-active={i + 1 === adjustedActiveSlide}
            >
              <div className="slide-card">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="images-wrapper">
        {carouselData.map((item, i) => (
          <img
            src={item.img}
            data-active={i + 1 === adjustedActiveSlide}
            alt={`Screens of the mobile application showing the following feature: ${item.title}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
